export const initialState = {
    sponsorsList: []
  };
